module.exports = __webpack_public_path__ + "img/[恐惧].a911e5bc.svg";